import { render, staticRenderFns } from "./RateSelect.vue?vue&type=template&id=595df7b2&scoped=true"
import script from "./RateSelect.vue?vue&type=script&lang=js"
export * from "./RateSelect.vue?vue&type=script&lang=js"
import style0 from "./RateSelect.vue?vue&type=style&index=0&id=595df7b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595df7b2",
  null
  
)

export default component.exports